"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityContext = void 0;
var react_1 = require("react");
var IdentityState_1 = require("./IdentityState");
var stub = function () {
    throw new Error("You forgot to wrap your component in <IdentityProvider>.");
};
var initialContext = __assign(__assign({}, IdentityState_1.initialIdentityState), { getAccessToken: stub, signinRedirect: stub, requestReauthentication: stub });
exports.IdentityContext = (0, react_1.createContext)(initialContext);
